import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageOrnex: React.FC = () => (
  <LocalSeoPage
    city="Ornex"
    slug="depannage-informatique-ornex"
    metaTitle="Dépannage Informatique Ornex | Technicien PC Pays de Gex"
    metaDescription="Technicien informatique à Ornex. PC lent, virus, WiFi, Windows. Intervention rapide à domicile ou à distance. Diagnostic gratuit."
    intro="Votre ordinateur vous pose problème à Ornex ? Notre technicien intervient rapidement, à domicile ou à distance. PC lent, virus, connexion WiFi instable ou Windows bloqué — diagnostic gratuit, devis clair, solution rapide."
    postalCode="01210"
    nearbyTowns={[
      { name: 'Saint-Genis-Pouilly', link: '/depannage-informatique-saint-genis-pouilly' },
      { name: 'Cessy', link: '/depannage-informatique-cessy' },
      { name: 'Ferney-Voltaire', link: '/depannage-informatique-ferney-voltaire' },
      { name: 'Gex', link: '/depannage-informatique-gex' },
      { name: 'Segny', link: '/depannage-informatique-segny' },
      { name: 'Prévessin-Moëns', link: '/depannage-informatique-prevessin-moens' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Saint-Genis-Pouilly', href: '/depannage-informatique-saint-genis-pouilly' },
      { label: 'Dépannage informatique à Cessy', href: '/depannage-informatique-cessy' },
      { label: 'Dépannage informatique à Ferney-Voltaire', href: '/depannage-informatique-ferney-voltaire' },
      { label: 'Dépannage informatique à Gex', href: '/depannage-informatique-gex' },
      { label: 'Dépannage informatique dans le Genevois', href: '/depannage-informatique-genevois' },
    ]}
  />
);

export default DepannageOrnex;
